__turbopack_context__.v({
  "Actions": "index-module__6jM9Na__Actions",
  "Backdrop": "index-module__6jM9Na__Backdrop",
  "Button": "index-module__6jM9Na__Button",
  "Center": "index-module__6jM9Na__Center",
  "Content": "index-module__6jM9Na__Content",
  "Description": "index-module__6jM9Na__Description",
  "Handle": "index-module__6jM9Na__Handle",
  "Indent": "index-module__6jM9Na__Indent",
  "IndentBackground": "index-module__6jM9Na__IndentBackground",
  "Popup": "index-module__6jM9Na__Popup",
  "Root": "index-module__6jM9Na__Root",
  "Title": "index-module__6jM9Na__Title",
  "Viewport": "index-module__6jM9Na__Viewport",
});
